import { Globe2, ArrowUpRight } from "lucide-react";

/* Site-wide top strip (always visible, above AAShell header).
   Scope of this site is India only; worldwide airports & airlines live on the
   sister property www.AirlinesAirports.com. */
export default function GlobalLinkStrip() {
  return (
    <div
      data-testid="aa-global-strip"
      className="w-full bg-gradient-to-r from-[#0A2A5E] via-[#143d82] to-[#1a4fa3] text-white"
    >
      <div className="max-w-7xl mx-auto px-3 sm:px-5 py-1.5 flex items-center justify-center sm:justify-end gap-2 sm:gap-3 text-[11px] sm:text-[12px] font-700">
        <span className="hidden sm:inline-flex items-center gap-1.5 text-white/80">
          <Globe2 className="w-3.5 h-3.5" />
          Looking for airports or airlines outside India?
        </span>
        <span className="sm:hidden inline-flex items-center gap-1 text-white/90">
          <Globe2 className="w-3.5 h-3.5" />
          Global airports & airlines →
        </span>
        <a
          href="https://www.airlinesairports.com"
          target="_blank"
          rel="noopener noreferrer"
          data-testid="aa-global-strip-link"
          className="notranslate inline-flex items-center gap-1 bg-white text-[#0A2A5E] rounded-full px-2.5 sm:px-3 py-0.5 sm:py-1 font-800 tracking-tight hover:bg-amber-300 hover:text-[#0A2A5E] transition-colors"
        >
          AirlinesAirports.com
          <ArrowUpRight className="w-3 h-3 sm:w-3.5 sm:h-3.5" />
        </a>
      </div>
    </div>
  );
}
